module.exports = __webpack_public_path__ + "static/media/org-info.5d0d6ff1.svg";